<div class="container">
  <mat-card>
    <form (ngSubmit)="onSubmit()" #emailForm="ngForm" class="full-width">
      <h2 style="text-align: center;" i18n="@@email-title">Entre tes identifiants The Bold Heads</h2>
      <mat-form-field class="full-width">
        <input matInput placeholder="Email" i18n-placeholder="@@email-emailPlaceholder" [formControl]="emailFormControl" [(ngModel)]="email" [errorStateMatcher]="matcher"/>
        <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')" i18n="@@email-enterEmailValid" >
          Merci d'entrer un email valide
        </mat-error>
        <mat-error *ngIf="emailFormControl.hasError('required')"  i18n="@@email-enterEmailRequired">
          Email <strong>requis</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width">
        <input matInput [formControl]="passwordFormControl" placeholder="Mot de passe" i18n-placeholder="@@email-passwordPlaceholder" [(ngModel)]="password"
               [type]="!hide ? 'password' : 'text'"/>
        <mat-icon matSuffix (click)="hide = !hide">{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        <mat-error *ngIf="passwordFormControl.hasError('required')" i18n="@@email-enterPasswordRequired">
          Mot de passe <strong>requis</strong>
        </mat-error>
      </mat-form-field>
      <br/>
      <div class="centered">
        <button mat-raised-button color="primary" type="submit" [disabled]="!emailForm.valid" i18n="@@email-letsGo">On y va!</button>
      </div>
      <div [hidden]="!error" class="alert alert-danger">
        <br/>
        <span i18n="@@email-errorUnknown">Une erreur s'est produite.</span>
        <br/>
        <span i18n="@@email-errorIsAccountCreated">Es-tu sur d'avoir créé un compte? </span>
      </div>
      <mat-card-footer class="bottomPad">
        <div fxFlex fxLayoutAlign="space-around center">
          <button mat-raised-button routerLink="/signup" class="alc" i18n="@@email-doNotHaveAnAccount">Je n'ai pas de compte</button>
        </div>
      </mat-card-footer>
    </form>
  </mat-card>
</div>
